module.exports = __webpack_public_path__ + "assets/img/topicon (4).ab5b72c1.svg";